module.exports = __webpack_public_path__ + "static/media/high-middle-2.bc463fcc.png";